import { Tabs, TabsProps } from './tabs';
import { useNavigate, useParams } from '@everlutionsk/ui-router';
import React from 'react';

export interface NavTabsProps<T> extends Omit<TabsProps<T>, 'value' | 'onChange'> {
  /**
   * @default 'tab'
   */
  readonly param?: string;
}

/**
 * Material UI tabs with state stored in the URL.
 */
export function NavTabs<T extends string>(props: NavTabsProps<T>) {
  const { param = 'tab', tabs } = props;
  const value = useParams([param])[param];
  const navigate = useNavigate();

  return (
    <Tabs
      tabs={tabs}
      value={value}
      onChange={value => navigate(`../${value}`)}
      sx={props.sx}
      action={props.action}
    />
  );
}
